module.exports = __webpack_public_path__ + "static/isha-187267e654982701850b70df721474cd.jpeg";